import PropTypes from 'prop-types'

export default {
  renderDate: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  onUnregistration: PropTypes.func.isRequired,
}
